import React, { useEffect } from 'react'
import { auth } from '../firebaseconfig'
import { Graph } from './Graph'
import { db } from '../firebaseconfig'
import { toast } from 'react-toastify'

export const Stats = ({wpm,Accuracy,correctchars,incorrect,extra,missedchar,graphdata,resetTest}) => {
  var timeset=new Set()

const newgraph =graphdata.filter((i)=>{
  if(!timeset.has(i[0])){
    timeset.add(i[0])
    return i;
  }
})
const pushTodb=()=>{
  const resultRef=db.collection('Results')
  const {uid}=auth. currentUser;
  if(isNaN(Accuracy))
  {
    toast.warning('invalid test', {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      });
      return;
  }
  resultRef.add({
    wpm:wpm,
    Accuracy:Accuracy,
    Characters:`${correctchars}/${incorrect}/${missedchar}/${extra}`,
    timeStamp:new Date(),
    userId:uid
  }).then((res)=>{
    toast.success('Data succesfully pushed to DB', {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      });
  }).catch((err)=>{
    toast.error('Failure white pushing to DB', {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      });
  })
}
    useEffect(()=>{
      if(auth.currentUser)
      {
        pushTodb()
      }
      else
      {
        toast.error('Login to save the result', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          });
      }
    })
  return (
    <div className='stats-box'>
        <div className='left'>
            <div className='title'>WPM </div>
            <div className='subtitle'>{wpm}</div>
            <div className='title'>Accuracy </div>
            <div className='subtitle'>{Accuracy}</div>
            <div className='title'>Characters</div>
            <div className='subtitle'>{correctchars}/{incorrect}/{missedchar}/{extra}</div>
            <div  className='Restart' onClick={resetTest}>Restart</div>
        </div>
        <div className='right'>
            <Graph graphdata={newgraph} width="70%"/> 
        </div>
    </div>
  )
}
